export default __webpack_public_path__ + "static/media/coinguy.c96f3f85.webp";